module.exports = __webpack_public_path__ + "static/media/avatar.92384b95.png";